import AuthService from '../services/AuthService';

// tslint:disable-next-line:no-any
export const customFetch = async (uri: string, options: any) => {
    const initialResponse = await fetch(uri, options);
    const secondResponse = initialResponse.clone();

    const json = await initialResponse.json();
    if (json && json.errors && json.errors[0] && json.errors[0].message === 'Forbidden resource') {
        if (AuthService.GetInstance().loggedIn) {
            AuthService.GetInstance().removeToken();
            window.location.href = '/';
            // FlashStore.GetInstance().showMessage('Byl jste odhlášen', 'failure');
        }
    }

    return secondResponse;
};



// WEBPACK FOOTER //
// ./src/domain/customFetch.ts